"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/InfoTab/Form/PatientPhonesToggle.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);

var _noticeBar = require('web/services/context/noticeBar');
var _Form = require('web/components/Form');

 const PATIENT_PHONES_TOGGLE_LABEL = "Don't allow users to see patient phone numbers"; exports.PATIENT_PHONES_TOGGLE_LABEL = PATIENT_PHONES_TOGGLE_LABEL
 const PATIENT_PHONES_TOGGLE_HINT =
  "Users who aren't admins see patient numbers masked and can't look patients up by phone. Admins still see them."; exports.PATIENT_PHONES_TOGGLE_HINT = PATIENT_PHONES_TOGGLE_HINT





// Admin-only: render it only for an admin of the org, since both commands
// refuse everyone else.
const PatientPhonesToggle = ({ orgKey }) => {
  // null until the current value has loaded; the toggle stays disabled until then.
  const [isHidden, setIsHidden] = _react.useState(null)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  // Generation guard: the settings route reuses this instance across orgs, so
  // a load or save that completes after switching org must not touch the new
  // org's toggle or show its notice there.
  const orgGenRef = _react.useRef.call(void 0, 0)

  _react.useEffect.call(void 0, () => {
    const gen = ++orgGenRef.current
    setIsHidden(null)
    setIsSaving(false)
    _actions2.default.getOrgPatientPhoneSettings({ OrgKey: orgKey })
      .then(r => { if (gen === orgGenRef.current) setIsHidden(r.HidePatientPhones) })
      .catch(() => {
        if (gen === orgGenRef.current) showWarningBar("Failed to load the patient phone number setting")
      })
    // Also retire this generation on unmount.
    return () => { orgGenRef.current += 1 }
  }, [orgKey, showWarningBar])

  const isDisabled = isHidden === null || isSaving
  const onChange = _react.useCallback.call(void 0, 
    (hide) => {
      // Toggle's isDisabled only styles it, so ignore clicks here.
      if (isDisabled) return
      const gen = orgGenRef.current
      setIsSaving(true)
      _actions2.default.updateOrgPatientPhoneSettings({ OrgKey: orgKey, HidePatientPhones: hide })
        .then(r => {
          if (gen !== orgGenRef.current) return
          setIsHidden(r.HidePatientPhones)
          showSuccessBar("Organization security settings updated")
        })
        .catch(() => {
          if (gen === orgGenRef.current) showWarningBar("Failed to update organization security settings")
        })
        .finally(() => { if (gen === orgGenRef.current) setIsSaving(false) })
    },
    [isDisabled, orgKey, showSuccessBar, showWarningBar],
  )

  return (
    _react2.default.createElement(_Form.Toggle, {
      className: "settings--org-info--mfa-toggle",
      label: exports.PATIENT_PHONES_TOGGLE_LABEL,
      hint: exports.PATIENT_PHONES_TOGGLE_HINT,
      isChecked: !!isHidden,
      isDisabled: isDisabled,
      onChange: onChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
    )
  )
}

exports. default = PatientPhonesToggle
